export enum PageFilterIdentifier {
  WorkingTimeManagement = 'working-time-management',
  ShiftOverview = 'shift-overview',
  Payroll = 'payroll',
  // Add more pages as needed
}

// Define which filters are persistent for each page
export const PERSISTENT_FILTERS_CONFIG: Record<string, string[]> = {
  [PageFilterIdentifier.ShiftOverview]: ['dates'],
  [PageFilterIdentifier.WorkingTimeManagement]: ['dates'],
  [PageFilterIdentifier.Payroll]: ['date'],
  // Add more page configurations as needed
};
